import React from 'react';
import { Navigate } from 'react-router-dom';
import { useProductContext } from '../context/ProductContext';
import { getStoredToken } from '../utils/auth';

const ProductAccessRoute = ({ children }) => {
    const {
        isSuperAdmin,
        products,
        selectedProductId,
        loadingProducts,
        canAccessProduct
    } = useProductContext();

    const token = getStoredToken();

    if (!token) {
        return <Navigate to="/login" replace />;
    }

    if (loadingProducts) {
        return null;
    }

    if (isSuperAdmin) {
        if (!selectedProductId) {
            return <Navigate to="/dashboard" replace />;
        }

        return children;
    }

    if (!Array.isArray(products) || products.length === 0) {
        return <Navigate to="/dashboard" replace />;
    }

    if (!selectedProductId || !canAccessProduct(selectedProductId)) {
        return <Navigate to="/dashboard" replace />;
    }

    return children;
};

export default ProductAccessRoute;
